import React, { useEffect, useState, useCallback } from 'react';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { Card } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Loading } from '@rd-web-markets/shared/dist/util';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import TechnicalUploadsForm from '@components/shared/technical_uploads/TechnicalUploadsForm';
import documentsService from '@services/claim_project_reports/documents_service';
import { Table } from '@rd-web-markets/shared/dist/util';
import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date/dateUtils';
const ProjectDocumentsSection = _ref => {
  let {
    isImmutableUnderReview,
    report,
    handleToaster,
    setReport
  } = _ref;
  const [uploads, setUploads] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const {
    t
  } = useTranslation();
  const fetchUploads = useErrorHandling(useCallback(async () => {
    const uploads = await documentsService.all(report.id);
    setUploads(uploads);
    setReport({
      ...report,
      additional_documentations: uploads
    });
  }, [report.id]));
  const handleSubmit = useErrorHandling(useCallback(async (document, file) => {
    if (!file) {
      handleToaster('Attach a file before submitting', 'warning');
    } else {
      setLoading(true);
      let fd = new FormData();
      fd.append('file', file);
      fd.append('additional_documentation', JSON.stringify(document));
      await documentsService.create(report.id, fd);
      await fetchUploads();
      setLoading(false);
    }
  }, [report.id]), () => {
    setLoading(false);
  });
  const handleDelete = useErrorHandling(useCallback(async uploadId => {
    if (window.confirm('Are you sure ?')) {
      setLoading(true);
      await documentsService.delete(report.id, uploadId);
      fetchUploads();
      setLoading(false);
    }
  }, [report.id]));
  const rows = upload => {
    return {
      key: upload.id,
      columns: [/*#__PURE__*/React.createElement("a", {
        rel: "noreferrer",
        href: upload?.document?.url,
        target: "_blank"
      }, /*#__PURE__*/React.createElement("small", null, upload?.document?.filename)), upload.comments, upload.uploaded_by, createTimezonedDate(new Date(upload.created_at)).toCustomLocaleDateString()],
      onDelete: () => handleDelete(upload.id)
    };
  };
  const headers = [{
    text: t('document_name')
  }, {
    text: t('document_comments')
  }, {
    text: t('uploaded_by')
  }, {
    text: t('date')
  }, {
    text: ''
  }];
  const tableRows = (report.additional_documentations || []).map(rows);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", {
    className: "text-primary mb-4"
  }, t('upload_document')), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(TechnicalUploadsForm, {
    isImmutableUnderReview: isImmutableUnderReview,
    handleSubmit: handleSubmit,
    loading: loading,
    showDocumentType: false
  }), /*#__PURE__*/React.createElement(Table, {
    isImmutableUnderReview: isImmutableUnderReview,
    headers: headers,
    rows: tableRows,
    onDelete: (index, row) => handleDelete(row.key)
  }))));
};
export default ProjectDocumentsSection;